import React from "react";
import iPhoneImage from "./Assets/Imgs/iPhoneImage.svg";

const HomepageImage = () => {
  return (
    <div className="homepage-image">
      <div className="rectangle">
        <img src={iPhoneImage} className="image" alt="" />
      </div>
    </div>
  )
}

export default HomepageImage;